<template>
  <Breadcrumbs
      title="Gate Pass In"
      :breadcrumbs="[
      { label: 'Stock', path: '' },
      { label: 'Gate Pass In', path: '/gate-pass-in' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <getPassInTable/>

    </div>
  </div>
</template>
<script >
import getPassInTable from '@/pages/stock/gate_pass_in/getPassInTable.vue'

export default {
  name:'indexList',
  components:{
    getPassInTable,
  },
}
</script>